'use strict';

var AppliedFiltersSummary = require('../flights_filters_summary/tags.model');
var ACTIVE_FIELD = 'active';

var FilterSummaryCollection = Backbone.Collection.extend({
    el: '.summary_container',
    model: AppliedFiltersSummary,
    clear: function(numberOfLegs) {
        Odigeo._.each(Odigeo._.range(numberOfLegs), Odigeo._.bind(function(legIndex) {
            var model = this.at(legIndex);
            var active = legIndex === 0;
            if (model) {
                model.resetTags();
                model.set(ACTIVE_FIELD, active);
            } else {
                this.add({
                    id: legIndex,
                    active: active,
                });
            }
        }, this));
    },
});

module.exports = Backbone.Model.extend({
    defaults: function() {
        return {
            active: false,
            filterSummary: new FilterSummaryCollection(),
        };
    },
    toggle: function() {
        var active = this.get(ACTIVE_FIELD);
        this.set(ACTIVE_FIELD, !active);
        return !active;
    },
});
